<div class="fcp-pagination">
    <button class="fcp-pagination-trigger" (click)="onClickPageTrigger(page - 1)">
        {{ previousPageTriggerLabel }}
    </button>

    <ng-container *ngFor="let pageTrigger of pageTriggerList">
        <span *ngIf="pageTrigger === 'ellipsis'" class="fcp-pagination-trigger">…</span>
        <button
            *ngIf="pageTrigger !== 'ellipsis'"
            class="fcp-pagination-trigger"
            [ngClass]="{ 'fcp-pagination-trigger--active': pageTrigger === page }"
            (click)="onClickPageTrigger(pageTrigger)"
        >
            {{ pageTrigger }}
        </button>
    </ng-container>

    <button class="fcp-pagination-trigger" (click)="onClickPageTrigger(page + 1)">
        {{ nextPageTriggerLabel }}
    </button>
</div>
